// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom';
import { injectGlobal, Theme } from './styled-components';

import App from './containers/App';
import 'antd/dist/antd.css';
import { DiagramClasses } from '@src/helpers/Enums';


// import * as serviceWorker from './serviceWorker';

var warn = console.warn;
console.warn = function (warning) {
    if (/(setState)/.test(warning)) {
        throw new Error(warning);
    }
    warn.apply(console, arguments);
};

injectGlobal`
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700');
  @import url('https://fonts.googleapis.com/css?family=Montserrat:300i,400,500,600,700,800|Quicksand:400,500,700&display=swap');

  *,
  *::after,
  *::before {
    box-sizing: border-box;
    outline: none;
  }

  html,
  body,
  #root {
    display: block;
    margin: 0;
    min-height: 100%;
    padding: 0;
    position: relative;
    width: 100%;
  }

  body.${DiagramClasses.TASKFLOW_MODAL_OPEN} {
      overflow-y: hidden;
  }

  body {
    background: ${Theme.background || 'red'};
    color: ${Theme.standard.textColor || '#333'};
    font-family: ${Theme.standard.font.family || 'sans-serif'};
    font-size: ${Theme.standard.font.size || '14px'};
    font-weight: ${Theme.standard.font.weight || '400'};
    line-height: ${Theme.standard.lineHeight || '1.25'};
  }

  h1,
  h2,
  h3,
  h4 {
    margin: 0 0 20px 0;
    padding: 0;
  }

  p {
    margin: 0 0 8px 0;
    padding: 0;
  }

  textarea:disabled,
  input:not([type]):disabled,
  input:disabled,
  select:disabled {
    background-color: #f2f2f2;

    &:-webkit-autofill {
      -webkit-text-fill-color: yellow !important;
    }
  }

  .custom-tooltip .ant-tooltip-inner{
    background-color: ${Theme.secondary.white};
    color: ${Theme.secondary.black};
    box-shadow: 1px 2px 10px ${Theme.secondary.midGrey};
    }
    .custom-tooltip .ant-tooltip-arrow{
        display: none;
    }

    .component-tooltip .ant-tooltip-inner{
        background-color: ${Theme.secondary.white};
        color: ${Theme.secondary.black};
        box-shadow: 1px 2px 10px ${Theme.secondary.midGrey};
        }
        .component-tooltip .ant-tooltip-arrow{
            display: none;
        }

  ::placeholder {
    color: #999;
    font-style: italic
  }
  

  .goepik-component-padding{
    padding-top: 24px!important;
}
.goepik-component-tablesize{
    width: 100%;
}

.goepik-btn-primary-main{
    font-weight: bold;
    text-transform: uppercase;
    font-size:15px;  
    padding-left:18px;
    padding-right:18px;
}

.goepik-btn-border-main{
    font-weight: bold;
    text-transform: uppercase;
    
    min-width:120px;
    border-color: #1890ff;
    color: #1890ff;    
}


.goepik-btn-border-red-main{
    border: 0px;
    min-width:120px;
    color: red;    
    background-color: none;
}

.goepik-btn-border-main-withoutbold{
    min-width:120px;
    color: #1890ff;  
    background-color: transparent;
    border: 0px;  
    :hover {
        min-width:120px;
        color: #1890ff;  
        background-color: transparent;
        border: 0px; 
    }
}

.goepik-btn-icon{
    color: #1890ff;  
    background-color: transparent;
    border: 0px;  
    :hover {
        color: #1890ff;  
        background-color: transparent;
        border: 0px; 
    }
}

.count-input{
    margin-top:2px;
    font-weight: bold;
    color: ${Theme.secondary.midGrey};
}
.count-input-red{
    margin-top:2px;
    color: ${Theme.secondary.red};
    font-weight: bold;
}
@keyframes shake {
    10%, 90% {
        transform: translate3d(-1px, 0, 0);
    }
  
    20%, 80% {
        transform: translate3d(2px, 0, 0);
    }
  
    30%, 50%, 70% {
        transform: translate3d(-4px, 0, 0);
    }
  
    40%, 60% {
        transform: translate3d(4px, 0, 0);
    }
}

.apply-shake {
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
}


.goepik-small-left-margin{    
    margin-left:6px;
}
.goepik-medium-left-margin{    
    margin-left:9px;
}
.goepik-big-left-margin{    
    margin-left:14px;
}

.goepik-small-top-margin{    
    margin-top:16px;
}
.goepik-medium-top-margin{    
    margin-top:20px;
}
.goepik-big-top-margin{    
    margin-top:28px;
}
.goepik-extra-big-top-margin{    
    margin-top:42px; 
}

.goepik-no-padding{

    .ant-modal-body{
        padding:0!important;
    }
}

.goepik-text-gray{
    font-weight: 900;
    color: ${Theme.standard.gray}!important;
}

.goepik-text-lightGray{
    color: ${Theme.standard.lightGray3}!important;
}
.goepik-text-lightGray-bold{
    color: ${Theme.standard.lightGray3}!important;
    font-weight: bold;
}

.goepik-execution-body{

    .execution-body{
        padding: 24px 24px 0 24px!important;
    }

    .goepik-score-text{
        text-align: center;
        font-weight: 900;
        font-size: -webkit-xxx-large;
    }

    .goepik-execution-close{
        margin-top: 5em;
        text-align: center;
    }

    .goepik-execution-footer{
        border-top-style: solid;
        border-top-width: 1.0px;
        border-top-color: ${Theme.standard.gray};
        padding: 0 24px 20px 24px;
        min-height: 60px;

    }

    .goepik-execution-footer-left{
        margin-top: 1em;
        position: absolute;
        left: 1em;
    }

    .goepik-execution-footer-right{
        margin-top: 1em;
        position: absolute;
        right: 1em;
    }
}

.goepik-modal-fullscreen {
    width: 100%!important;
    top: 0;
    bottom: 0;
    height: 100%;
    padding-bottom: 0;

    .ant-modal-content{
        height: 100%
    }
    .ant-modal-body {
        height: 100%;
        overflow-y: scroll;
    }
}

.formflow-fullscreen {
    width: 100%!important;
    top: 0;
    bottom: 0;
    height: 100%;
    padding-bottom: 0;

    .ant-modal-content{
        height: 100%
    }
    .ant-modal-body {
        height: 100%;
        overflow-y: scroll;
        padding: 0px;        
    }
}

.section-condition-fullscreen {
    width: 100%!important;
    top: 0;
    bottom: 0;
    height: 100%;
    padding-bottom: 0;
    border-radius: 0;

    .ant-modal-content{
        height: 100%
    }
    .ant-modal-body {
        height: 100%;
        overflow-y: auto;
        padding-left: 50px;  
        padding-right: 50px;  
        background-color:  #F6FBFF;

    }
}

.taskflow-fullscreen {
    width: 100vw !important;
    height: 100vh;
    top:0;
    bottom:0;
    overflow-y: hidden;
    .taskflow-checkbox-column{
        width: 30px; !important;
    }
    .taskflow-checkbox-title {
        margin-bottom: 10px;
    }
    .ant-modal-body {
        padding: 0;
    }
}

.slick-current{
    z-index: 10000;
}

.goepik-clickable{
    cursor: pointer;
}

.ant-btn-background-ghost.ant-btn-primary {
    border-style: hidden;
}

.generate-group, .image-recognition-modal {
    .ant-modal-header {
        background: #335D7C;
        .ant-modal-title {
            color: #ffffff;
            font-family: Montserrat;
            font-style: normal;
            font-weight: bold;
            font-size: 20px;
        }
    }
}
`;

ReactDOM.render(<App />, document.getElementById('root'));

// serviceWorker.unregister();
